angular.module("digitalLeasing.module")
.component("additionalConfigurations", {
  templateUrl: "ng/components/digitalLeasing/financialData/additionalConfigurations/additionalConfigurations.view.html",
  bindings: {
    model: "=",
    listOfValue: "<",
    importo:'<',
    validatePage: '&',
    invalidatePage: '&',
    callCalcolaCanoneTasso:'&'
  },
  controllerAs: "additionalConfigurationsCtrl",
  controller: AdditionalConfigurationsController
});

function AdditionalConfigurationsController(
  $rootScope,
  $scope,
  CondizioniAggiuntive,
  $timeout
  ){
    var self = this;
    self.$rootScope= $rootScope;
    self.$onInit = function(){
      self.model= self.model;
      $timeout(function(){
        checkElementIsPresent();
        checkPage();
      },1000)
      

    }

    self.$onChanges = function(changed){

      if(changed.importo && changed.importo.currentValue){
        calcPercentualeImporto();
      }
    }


    self.additionalChange = function(name, value){

      if(name == 'additional_amount'){  

        if(value > self.massimoValore ||
        value < self.minimoValore || (value =="" && self.model)){
          $scope.additionalConditionForm && $scope.additionalConditionForm['additional_amount'].$setValidity(
            "'additional_amount'",
            false
          );
          jQuery("#additional_amount").addClass("has-error");
          self.enabledErrorImport = true;
          self.textMessage="L'importo è fuori dal range consentito.<br/>Min: "+self.minimoValore+";<br/>Max: "+self.massimoValore+";"
          checkPage();
        }else{
          $scope.additionalConditionForm && $scope.additionalConditionForm['additional_amount'].$setValidity(
            "'additional_amount'",
            true
          );
          jQuery("#additional_amount").removeClass("has-error");
          self.enabledErrorImport = false;
          checkPage();

        }
        self.callCalcolaCanoneTasso({value: true})
      }else if(name == 'condition'){
        calcPercentualeImporto();
      }
    }

    var checkPage = function(){

      if((self.model && self.model.id && !self.enabledErrorImport )|| (!self.model)){
        self.validatePage();
      }else{
        self.invalidatePage();
      }
    }

    var checkElementIsPresent = function(){
      if(self.model.id){
        var test = self.listOfValue.every(function(element){
          return element.id == self.model.id;
        });

        if(!test){
          self.model= Object.assign({}, CondizioniAggiuntive.build());
        }

      }
    }

    var calcPercentualeImporto = function(){
      if(self.model && self.model.validations){
        self.model.validations.importoPerc.minimo.valore = self.model.validations.importoPerc.minimo.valore ?self.model.validations.importoPerc.minimo.valore :0
        self.massimoValore = self.importo * self.model.validations.importoPerc.massimo.valore /100;
        self.minimoValore = self.importo * self.model.validations.importoPerc.minimo.valore /100
      }
      

    }
}